import { useEffect, useState } from 'react';

export default function ReloadRequiredPrompt() {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState<string>('');

  useEffect(() => {
    const handler = (ev: Event) => {
      const detail = (ev as CustomEvent<any>)?.detail;
      const msg = String(detail?.reason || detail?.message || '');
      setReason(msg);
      setOpen(true);
    };

    window.addEventListener('app:reload-required', handler as any);
    return () => window.removeEventListener('app:reload-required', handler as any);
  }, []);

  if (!open) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[9999] max-w-xl mx-auto animate-in slide-in-from-bottom duration-300">
      <div className="bg-white dark:bg-gray-900 rounded-xl shadow-2xl border-2 border-amber-400 dark:border-amber-600 p-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 text-2xl">⚠️</div>
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-gray-900 dark:text-white mb-1">Actualización necesaria</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Para evitar perder tu trabajo, la app no se recargó automáticamente. Si notas algo raro, recarga cuando termines.
            </p>
            {reason ? (
              <p className="mt-2 text-[11px] font-mono text-gray-500 dark:text-gray-500 break-words line-clamp-2">
                {reason}
              </p>
            ) : null}
            <div className="mt-3 flex gap-2">
              <button
                onClick={() => window.location.reload()}
                className="flex-1 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white text-sm font-medium rounded-lg transition-colors"
              >
                Recargar
              </button>
              <button
                onClick={() => setOpen(false)}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 text-sm font-medium rounded-lg transition-colors"
              >
                Ahora no
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
